var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g2, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _g3, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _g4, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCelebration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M441 207.67C433 177.01 419.69 148.43 405.77 128.82C372.25 81.7 294.45 61 240.7 80.7C194.9 97.52 178.86 148.38 138.86 172.7C102.05 195.1 68.6498 213.37 55.7698 256.08C28.5798 346.31 136.12 418.24 216.48 395.35C241.84 388.13 263.28 372.93 290.33 372.84C345.21 372.65 364.54 380.18 408.94 350.53C452.69 321.36 455 261.35 441 207.67Z",
    fill: "#226BF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M441 207.67C433 177.01 419.69 148.43 405.77 128.82C372.25 81.7 294.45 61 240.7 80.7C194.9 97.52 178.86 148.38 138.86 172.7C102.05 195.1 68.6498 213.37 55.7698 256.08C28.5798 346.31 136.12 418.24 216.48 395.35C241.84 388.13 263.28 372.93 290.33 372.84C345.21 372.65 364.54 380.18 408.94 350.53C452.69 321.36 455 261.35 441 207.67Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M397.41 407.52C422.716 407.52 443.23 403.114 443.23 397.68C443.23 392.245 422.716 387.84 397.41 387.84C372.104 387.84 351.59 392.245 351.59 397.68C351.59 403.114 372.104 407.52 397.41 407.52Z",
    fill: "#226BF6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.41 407.52C422.716 407.52 443.23 403.114 443.23 397.68C443.23 392.245 422.716 387.84 397.41 387.84C372.104 387.84 351.59 392.245 351.59 397.68C351.59 403.114 372.104 407.52 397.41 407.52Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M354.22 193.58C354.22 193.58 354.22 196.95 347.22 191.44C340.22 185.93 338.95 180.73 348.75 174.91C356.27 170.44 368.33 168.84 374.68 176.28C379.52 181.95 379.61 190.77 384.88 196.03C389.77 200.93 401.1 202.16 405.69 212.87C410.28 223.58 402.63 221.75 406 232.47C409.37 243.19 418.25 243.79 412.73 254.47C407.21 265.15 397.43 271.92 382.43 265.18C367.43 258.44 371.71 247.73 361.92 241.3C343.57 229.33 341.13 210.74 354.22 193.58Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M357.42 202.77C355.586 207.109 354.981 211.87 355.67 216.53",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M361.14 180.34C362.58 183.07 365.73 187 372.68 190.69C385.01 197.25 389.68 199.18 389.68 199.18",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M360 176.81C360.038 177.234 360.122 177.654 360.25 178.06",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M400.86 214.77C401.136 215.584 401.255 216.442 401.21 217.3",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M370.14 193.28C370.14 193.28 373.83 196.48 383.09 200.33C389.9 203.17 396.71 207.68 399.68 212.33",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M358 173.73C358 173.73 351.31 173.82 355.43 182.26",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M375 196.86C377.898 200.969 381.122 204.838 384.64 208.43C390.04 213.83 389.27 220 388.11 222.7",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M394.63 311.76C394.63 311.76 385.45 334.76 383.92 343.9C382.39 353.04 380.74 365.24 378.68 371.09C376.05 378.54 372.28 382.48 372.59 385.23C372.9 387.98 380.24 395.95 377.49 398.09C374.74 400.23 369.22 390.44 369.49 384.93C369.76 379.42 373.77 364.11 374.39 354.62C375.01 345.13 372.86 331.04 374.08 322.78C375.3 314.52 377.14 307.47 377.14 307.47C377.14 307.47 387.59 302.57 394.63 311.76Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M375.34 314.51C375.34 314.51 383.92 325.84 386.06 335.94C388.459 346.285 393.052 355.995 399.53 364.41C405.35 371.76 410.16 385.11 410.16 385.11C410.16 385.11 409.55 395.21 410.77 398.27C411.99 401.33 415.36 398.88 415.67 393.98C415.98 389.08 413.67 382.91 412.42 379.85C411.17 376.79 407.49 359.85 404.42 350.33C401.35 340.81 398.6 329.21 396.15 322.78C393.7 316.35 390.34 308.39 390.34 308.39C390.34 308.39 374.43 306.86 375.34 314.51Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M389.73 225.73L388.82 232.16C388.82 232.16 387 246.85 387 252.06C387 257.27 394 268.59 395.57 284.82C397.14 301.05 394.65 311.76 394.65 311.76C379.65 308.7 375.36 314.51 375.36 314.51C375.36 314.51 362.2 298.29 360.36 287.88C358.52 277.47 363.12 266.75 363.73 258.49C364.34 250.23 359.14 243.79 354.24 234.3C349.34 224.81 349.04 214.71 354.55 213.79C360.06 212.87 368.02 213.48 368.02 213.48C368.02 213.48 380.57 214.4 386.08 215.93C391.59 217.46 391.9 220.53 391.9 220.53",
    fill: "#226BF6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M389.73 225.73L388.82 232.16C388.82 232.16 387 246.85 387 252.06C387 257.27 394 268.59 395.57 284.82C397.14 301.05 394.65 311.76 394.65 311.76C379.65 308.7 375.36 314.51 375.36 314.51C375.36 314.51 362.2 298.29 360.36 287.88C358.52 277.47 363.12 266.75 363.73 258.49C364.34 250.23 359.14 243.79 354.24 234.3C349.34 224.81 349.04 214.71 354.55 213.79C360.06 212.87 368.02 213.48 368.02 213.48C368.02 213.48 380.57 214.4 386.08 215.93C391.59 217.46 391.9 220.53 391.9 220.53",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M376.55 272.16C376.55 272.16 387.17 288.6 390.93 300.92",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M373.81 266.68C373.81 266.68 382.37 274.9 385.45 281.06",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M363.1 208C363.1 208 366.47 215.35 366.47 216.58C366.47 217.81 372.9 223.92 375.04 222.39C377.18 220.86 375.65 217.19 374.12 213.82C372.59 210.45 369.53 204.94 369.53 204.94C368.727 205.866 367.741 206.615 366.634 207.142C365.528 207.668 364.324 207.961 363.1 208Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M355.45 182.26L350.85 192.36C350.85 192.36 353.91 201.24 357.28 205.52C360.65 209.8 365.28 210.12 367.69 208.59C372.43 205.59 370.14 193.28 370.14 193.28C370.14 193.28 356.67 188.07 355.45 182.26Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M388.2 216.55C393.113 219.018 397.86 221.803 402.41 224.89C408.03 228.75 422.41 244.08 420.32 248.06C418.23 252.04 393.46 266.06 391.93 266.06C390.4 266.06 388.51 264.06 388.51 264.06C388.51 264.06 386.32 261.01 385.1 261.01C383.88 261.01 385.96 258.15 387.79 257.23C389.62 256.31 392.46 262.8 392.46 262.8C392.46 262.8 407.11 248.28 408.03 245.21C408.95 242.14 385.75 231.81 385.75 231.81",
    fill: "#226BF6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M388.2 216.55C393.113 219.018 397.86 221.803 402.41 224.89C408.03 228.75 422.41 244.08 420.32 248.06C418.23 252.04 393.46 266.06 391.93 266.06C390.4 266.06 388.51 264.06 388.51 264.06C388.51 264.06 386.32 261.01 385.1 261.01C383.88 261.01 385.96 258.15 387.79 257.23C389.62 256.31 392.46 262.8 392.46 262.8C392.46 262.8 407.11 248.28 408.03 245.21C408.95 242.14 385.75 231.81 385.75 231.81",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M354.53 213.79C354.53 213.79 346.53 215.32 346.87 222.06C347.21 228.8 345.65 264.92 348.71 265.84C351.77 266.76 378.41 243.49 378.41 243.49C378.41 243.49 384.22 245.32 385.41 244.71C386.6 244.1 386.33 242.57 387.24 240.12C388.15 237.67 389.08 237.36 384.8 237.67C382.9 237.81 380.02 237.54 378.34 238.67C375.57 240.48 373.96 243.39 371.06 245.26C367.267 247.693 363.384 249.983 359.41 252.13C353.41 255.35 355.69 242.55 355.97 239.74C356.37 235.58 356.91 231.42 357.55 227.29",
    fill: "#226BF6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M354.53 213.79C354.53 213.79 346.53 215.32 346.87 222.06C347.21 228.8 345.65 264.92 348.71 265.84C351.77 266.76 378.41 243.49 378.41 243.49C378.41 243.49 384.22 245.32 385.41 244.71C386.6 244.1 386.33 242.57 387.24 240.12C388.15 237.67 389.08 237.36 384.8 237.67C382.9 237.81 380.02 237.54 378.34 238.67C375.57 240.48 373.96 243.39 371.06 245.26C367.267 247.693 363.384 249.983 359.41 252.13C353.41 255.35 355.69 242.55 355.97 239.74C356.37 235.58 356.91 231.42 357.55 227.29",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M384.84 237.67C382.94 237.81 380.06 237.54 378.38 238.67C375.61 240.48 374 243.39 371.1 245.26C367.306 247.693 363.423 249.983 359.45 252.13C354.1 255.02 355.36 245.02 355.87 240.9C352.659 241.176 349.549 242.156 346.76 243.77C346.76 254.62 347.06 265.37 348.71 265.87C351.77 266.78 378.41 243.52 378.41 243.52C378.41 243.52 384.22 245.35 385.41 244.74C386.6 244.13 386.33 242.6 387.24 240.15C388.15 237.7 389.12 237.36 384.84 237.67Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M420.32 248.06C421.84 245.24 415.03 236.71 408.93 230.61C404.658 231.894 400.842 234.371 397.93 237.75C403.37 240.63 408.5 243.75 408.06 245.25C407.14 248.32 392.49 262.84 392.49 262.84C392.49 262.84 389.66 256.35 387.82 257.27C385.98 258.19 383.9 261.05 385.13 261.05C386.36 261.05 388.54 264.1 388.54 264.1C388.54 264.1 390.43 266.1 391.96 266.1C393.49 266.1 418.18 252 420.32 248.06Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M414.47 385.69C413.854 385.222 413.111 384.951 412.338 384.913C411.565 384.876 410.799 385.073 410.14 385.48C410.04 387.32 409.68 395.56 410.77 398.27C412 401.33 415.36 398.88 415.67 393.98C415.724 391.17 415.319 388.37 414.47 385.69Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M372.63 384.36C371.63 383.98 370.48 384.06 369.53 385.83C369.8 391.44 374.88 400.12 377.53 398.09C380.18 396.06 372.94 387.99 372.63 385.23C372.591 384.941 372.591 384.649 372.63 384.36Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M296.74 407.52C322.046 407.52 342.56 403.115 342.56 397.68C342.56 392.246 322.046 387.84 296.74 387.84C271.434 387.84 250.92 392.246 250.92 397.68C250.92 403.115 271.434 407.52 296.74 407.52Z",
    fill: "#226BF6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.74 407.52C322.046 407.52 342.56 403.115 342.56 397.68C342.56 392.246 322.046 387.84 296.74 387.84C271.434 387.84 250.92 392.246 250.92 397.68C250.92 403.115 271.434 407.52 296.74 407.52Z",
    fill: "white"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M275.87 274.23C275.87 274.23 271.2 287.89 270.87 289.69C270.54 291.49 263.71 314.26 262.21 328.69C260.71 343.12 262.51 346.98 267.6 357.18C272.69 367.38 282.9 389.56 282.9 389.56L287.1 389.26C287.1 389.26 284.7 363.78 282.6 355.08C280.5 346.38 277.8 339.19 278.7 334.39C279.6 329.59 290.36 302.92 290.36 302.92C290.36 302.92 292.79 326.59 294.29 342.78C295.79 358.97 313.19 394.96 313.19 394.96L317.38 394.36C317.38 394.36 317.68 368.87 315.58 358.68C313.48 348.49 313.49 346.38 313.49 336.19C313.49 326 309.43 294.12 310.15 289.43C310.96 284.12 308.96 277.43 308.96 277.43C308.96 277.43 283.07 279 275.87 274.23Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M284.729 293.76L290.399 302.88L278.689 296.48",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M303.77 280.47C303.411 281.394 303.252 282.383 303.303 283.372C303.355 284.362 303.616 285.329 304.07 286.21C304.556 287.193 305.279 288.039 306.175 288.671C307.071 289.304 308.111 289.702 309.2 289.83C309.2 289.83 310.71 333.33 310.41 336.36",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M310.71 340.58C310.71 340.58 311.02 345.12 311.02 348.74C311.02 352.36 316.15 366.26 316.15 373.21",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M333.54 255.87C328.74 243.27 304.79 219.75 300.54 216.75C296.29 213.75 288.54 214.05 288.54 214.05C282.923 213.25 277.808 210.378 274.2 206C267.91 198.5 261.01 185.6 260.41 178.71C259.81 171.82 258.61 153.82 258.61 153.82C258.61 153.82 261.91 146.02 261.61 143.62C261.31 141.22 257.11 138.82 254.11 140.92C251.11 143.02 249.61 145.72 251.11 149.02C251.956 150.706 252.465 152.54 252.61 154.42C251.073 166.8 251.478 179.345 253.81 191.6C257.71 211.09 267.63 223.99 270.33 228.78C273.03 233.57 275.27 268.27 275.27 273.07C275.27 277.87 277.37 279.07 286.06 279.67C294.75 280.27 307.2 279.25 309 277.45C310.8 275.65 309.59 247.68 309.59 247.68C309.59 247.68 325.18 264.77 327.88 267.17C330.58 269.57 338.34 268.46 333.54 255.87Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M333.54 255.87C328.74 243.27 304.79 219.75 300.54 216.75C296.29 213.75 288.54 214.05 288.54 214.05C282.923 213.25 277.808 210.378 274.2 206C269.188 199.819 265.142 192.914 262.2 185.52L253.09 187.52C253.3 188.86 253.54 190.22 253.81 191.58C257.71 211.07 267.63 223.97 270.33 228.76C273.03 233.55 275.27 268.25 275.27 273.05C275.27 277.85 277.37 279.05 286.06 279.65C294.75 280.25 307.2 279.23 309 277.43C310.8 275.63 309.59 247.66 309.59 247.66C309.59 247.66 325.18 264.75 327.88 267.15C330.58 269.55 338.34 268.46 333.54 255.87Z",
    fill: "#226BF6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M334.78 256.75C334.78 256.75 333.37 251.99 325.43 251.81C317.49 251.63 315.2 257.45 317.14 261.33C319.08 265.21 323.67 270.68 330.37 268.92C337.07 267.16 336.72 260.63 334.78 256.75Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M296.55 212.18C296.55 212.18 299.47 212.7 300.16 215.28C300.799 218.001 300.74 220.838 299.99 223.53C299.3 225.42 296.72 230.24 296.72 230.24C296.72 230.24 290.18 222.33 289.32 221.81C288.46 221.29 279.32 223.7 279.32 223.7C279.32 223.7 280.52 216.31 283.32 213.56C286.12 210.81 294.83 211.84 296.55 212.18Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M299 206.34C299 206.34 297.11 213.04 297.11 215.62C297.11 218.2 289.2 228.18 289.2 228.18L285.93 214.76L287.31 205.99C287.31 205.99 294.31 210.12 299 206.34Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M284.85 186.22C284.85 186.22 284.34 195.33 282.79 199.11C281.24 202.89 282.45 208.92 286.23 211.11C290.01 213.3 295.69 210.94 298.95 208.7C302.21 206.46 303.77 201.82 305.49 196.7C307.21 191.58 307.38 184.14 301.88 181.7C296.38 179.26 284.85 186.22 284.85 186.22Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M302.53 201.23C302.53 201.23 301.65 200.94 300.77 198.31C299.89 195.68 302.53 195.38 302.53 192.16C302.53 188.94 299.6 185.16 295.53 186.3C290.686 187.431 285.627 187.227 280.89 185.71C277.08 184.25 278.55 175.17 286.45 173.41C294.35 171.65 291.14 177.22 294.36 177.22C297.58 177.22 302.85 174 304.36 176.64C305.87 179.28 304.06 181.03 306.36 182.2C308.66 183.37 310.45 184.25 310.45 188.06C310.45 191.87 305.18 200.65 305.18 200.65C305.18 200.65 304.29 204.16 302.53 201.23Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M301 203.07C301 203.07 303.23 198.6 305.3 199.46C307.37 200.32 305.99 202.72 303.75 204.62C301.51 206.52 300.14 205.82 300.14 205.82",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M301 203.07C301 203.07 303.23 198.6 305.3 199.46C307.37 200.32 305.99 202.72 303.75 204.62C301.51 206.52 300.14 205.82 300.14 205.82",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M325.78 255.13C325.78 255.13 322.08 254.98 312.29 251.84C303.35 248.96 300.75 246.4 298.45 245.36C296.78 244.61 291.66 243.44 291.06 245.24C290.46 247.04 294 247.3 294 247.3C294 247.3 294.3 247.9 296.1 250.89C297.9 253.88 302.1 252.39 303.3 252.39C304.5 252.39 318.6 264.73 323.39 267.39C328.18 270.05 334.79 268.29 334.79 263.79C334.79 259.29 334.78 256 325.78 255.13Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M260.109 149.88C260.109 149.88 264.309 146.58 261.609 143.58C258.909 140.58 253.209 144.18 253.509 145.68C253.809 147.18 257.709 145.68 257.709 145.68C257.709 145.68 255.309 148.68 256.509 150.18",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M260.109 149.88C260.109 149.88 264.309 146.58 261.609 143.58C258.909 140.58 253.209 144.18 253.509 145.68C253.809 147.18 257.709 145.68 257.709 145.68C257.709 145.68 255.309 148.68 256.509 150.18",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M313.23 394.92C313.23 394.92 305.73 403.92 307.83 407.82C309.93 411.72 316.83 404.22 317.42 394.32L313.23 394.92Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M282.94 389.52C282.94 389.52 272.74 392.82 272.74 397.92C272.74 403.02 285.04 393.72 287.14 389.22L282.94 389.52Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M261.78 181.57C260.05 181.35 251.18 182.93 251.18 185.14C251.18 186.37 251.71 190.25 252.94 190.61C254.17 190.97 263.52 189.2 264.05 188.67C264.58 188.14 263.11 182.01 262.45 181.73C262.234 181.648 262.009 181.594 261.78 181.57Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M202.82 407.52C228.126 407.52 248.64 403.114 248.64 397.68C248.64 392.245 228.126 387.84 202.82 387.84C177.514 387.84 157 392.245 157 397.68C157 403.114 177.514 407.52 202.82 407.52Z",
    fill: "#226BF6"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.82 407.52C228.126 407.52 248.64 403.114 248.64 397.68C248.64 392.245 228.126 387.84 202.82 387.84C177.514 387.84 157 392.245 157 397.68C157 403.114 177.514 407.52 202.82 407.52Z",
    fill: "white"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M212.08 206.61C212.08 206.61 208.45 214.12 208.45 217.23C208.397 218.804 208.572 220.377 208.97 221.9L199.38 212.83C199.38 212.83 203.01 204.54 203.27 202.98C203.53 201.42 212.08 206.61 212.08 206.61Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M214.41 183.54C216.11 185.18 217.128 187.402 217.26 189.76C217.26 193.39 218.26 196.24 219.59 196.5C220.92 196.76 218.82 198.32 218.82 198.32L217.82 199.61C217.82 199.61 218.34 206.35 215.49 208.68C212.64 211.01 202.27 204.28 202.27 204.28C202.27 204.28 202.27 200.13 202.79 192.61C203.31 185.09 208.45 182 214.41 183.54Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M214.41 186.91C215.605 186.775 216.743 186.319 217.7 185.59C218.658 184.861 219.401 183.887 219.85 182.77C221.41 178.88 220.11 170.84 212.08 169.77C204.05 168.7 208.19 173.4 203.27 175.21C198.35 177.02 190.05 175.73 186.68 182.73C183.31 189.73 187.46 198.53 186.42 201.39C185.38 204.25 175.28 208.39 170.61 216.39C165.94 224.39 175.02 241.53 174.24 245.67C173.46 249.81 167.24 253.45 170.61 261.48C173.98 269.51 186.16 274.18 196.27 267.48C206.38 260.78 201.19 236.64 197.05 230.16C192.91 223.68 200.77 210.83 205.17 206.42C209.57 202.01 206.38 193.1 206.38 189.73C206.38 186.36 214.41 186.91 214.41 186.91Z",
    fill: "#226BF6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M219.82 177.23C219.82 177.23 222.03 181.65 213.19 183.13C204.35 184.61 195.19 188.65 195.88 194.91C196.57 201.17 196.62 213.69 188.15 217.74C179.68 221.79 173.79 224.74 172.68 234.68",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M174.149 266.36C174.149 266.36 168.999 259.36 175.629 249.78C182.259 240.2 187.779 234 193.999 224",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M186.42 201.43C187.51 197.757 188.092 193.951 188.15 190.12C188.15 184.23 194.04 178.34 201.77 177.97C209.5 177.6 216.87 176.5 216.14 171.71",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M199.12 268C199.12 268 193.68 276.29 198.12 290.81C202.56 305.33 209.53 323.98 209.27 329.68C209.01 335.38 205.9 345.23 205.9 353C205.9 360.77 203.31 383.59 203.31 383.59L207.97 385.4C207.97 385.4 220.41 354.04 222.23 341.08C224.05 328.12 224.3 306.36 224.3 306.36C224.3 306.36 225.85 286.14 221.19 268.52C221.15 268.55 204.56 263.11 199.12 268Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M210.61 299.5C210.61 299.5 216.35 325.18 216.35 332.43C216.35 339.68 206.35 384.09 206.35 384.09",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M243.829 215.85C242.689 214.7 239.829 217.56 239.399 218.85C238.969 220.14 240.109 227.15 240.109 227.15C240.109 227.15 229.699 249.15 226.849 249.89C223.999 250.63 217.259 239.52 217.259 239.52L216.739 254.52C216.739 254.52 226.589 263.85 229.959 262.04C233.329 260.23 243.959 226.78 243.959 226.78C244.241 225.23 244.687 223.715 245.289 222.26C246.119 220.43 244.999 217 243.829 215.85Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M239.829 224.15C239.829 224.15 238.109 219 238.109 217.42C238.184 215.204 238.472 213.001 238.969 210.84C239.399 209.26 240.689 210.84 240.689 212.27C240.656 213.468 240.559 214.663 240.399 215.85C240.399 215.85 242.119 218.14 241.969 220L241.829 221.86",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M239.829 224.15C239.829 224.15 238.109 219 238.109 217.42C238.184 215.204 238.472 213.001 238.969 210.84C239.399 209.26 240.689 210.84 240.689 212.27C240.656 213.468 240.559 214.663 240.399 215.85C240.399 215.85 242.119 218.14 241.969 220L241.829 221.86",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M247.6 209.7C247.466 209.395 247.272 209.121 247.03 208.892C246.787 208.664 246.502 208.486 246.19 208.37C245.67 208.2 245.13 208.26 245.08 209.2C244.98 211.09 246.24 219.57 246.53 217.71C246.78 216.06 248.51 211.66 247.6 209.7Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M246.599 211.26C246.467 210.954 246.273 210.679 246.031 210.45C245.789 210.222 245.502 210.045 245.189 209.93C244.669 209.75 244.129 209.81 244.079 210.76C243.979 212.64 246.239 218.59 246.529 216.76C246.779 215.08 247.509 213.22 246.599 211.26Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M246.38 213.14C246.196 212.749 245.896 212.424 245.52 212.21C244.92 211.87 244.02 211.59 243.95 212.83C243.85 214.71 246.01 219.92 246.3 218.06C246.59 216.2 247.39 215.19 246.38 213.14Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M245.569 214.93C245.437 214.624 245.243 214.349 245.001 214.12C244.758 213.892 244.472 213.715 244.159 213.6C243.639 213.42 243.159 213.49 243.059 214.43C242.959 216.31 245.679 222.06 245.969 220.2C246.412 218.446 246.271 216.597 245.569 214.93Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M193.719 213.77C194.08 213.193 194.561 212.7 195.129 212.325C195.697 211.95 196.34 211.702 197.012 211.597C197.685 211.493 198.373 211.535 199.028 211.72C199.683 211.905 200.29 212.229 200.809 212.67C205.879 216.9 215.449 224.94 218.809 228.12C223.469 232.52 219.809 240.82 219.809 244.19C219.809 247.56 221.369 269.07 221.369 270.36C221.369 271.65 216.699 273.21 211.519 271.92C206.339 270.63 199.119 268 199.119 268C199.119 268 201.709 255 199.639 250.9C197.819 247.29 187.259 224.58 193.719 213.77Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M199.379 269.58C199.379 269.58 192.379 277.58 194.449 287.99C196.519 298.4 205.859 300.68 211.039 304.83C216.219 308.98 232.549 319.34 232.549 319.34C232.549 319.34 222.439 328.93 217.259 337.49C212.079 346.05 202.259 353.81 202.259 353.81L204.849 357.7C204.849 357.7 229.989 339.56 237.759 332.56C245.529 325.56 250.759 320.12 250.759 317.56C250.759 315 229.999 292.13 223.999 284.62C220.046 279.895 214.967 276.243 209.229 274",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M199.379 269.58C199.379 269.58 192.379 277.58 194.449 287.99C196.519 298.4 205.859 300.68 211.039 304.83C216.219 308.98 232.549 319.34 232.549 319.34C232.549 319.34 222.439 328.93 217.259 337.49C212.079 346.05 202.259 353.81 202.259 353.81L204.849 357.7C204.849 357.7 229.989 339.56 237.759 332.56C245.529 325.56 250.759 320.12 250.759 317.56C250.759 315 229.999 292.13 223.999 284.62C220.046 279.895 214.967 276.243 209.229 274",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M232.55 319.34C235.63 318.022 239.003 317.535 242.33 317.93",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M201.849 272C201.849 272 197.919 280.76 201.849 286.2C205.779 291.64 234.779 314.9 237.199 316.1C239.619 317.3 241.119 318.52 239.609 320.33C238.099 322.14 204.609 355.38 204.609 355.38",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M205.08 220.34C205.08 220.34 201.52 210.75 195.65 211.93C187.65 213.52 189.27 250.15 187.2 251.18C185.13 252.21 171.13 229.67 170.09 228.38C169.05 227.09 170.87 225.53 168.02 223.2C165.17 220.87 164.65 221.9 161.54 220.09C158.43 218.28 157.39 219.31 157.65 220.6C157.91 221.89 162.32 223.45 162.32 223.45C162.32 223.45 156.62 223.45 154.03 222.68C151.44 221.91 153.03 223.68 153.77 225.01C154.51 226.34 159.47 228.38 161.28 228.38C162.859 228.479 164.424 228.74 165.95 229.16C165.95 229.16 173.95 248.85 177.87 254.04C181.79 259.23 186.68 267.77 191.09 263.11C195.5 258.45 202.23 228.64 202.23 228.64",
    fill: "#263238"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M205.08 220.34C205.08 220.34 201.52 210.75 195.65 211.93C187.65 213.52 189.27 250.15 187.2 251.18C185.13 252.21 171.13 229.67 170.09 228.38C169.05 227.09 170.87 225.53 168.02 223.2C165.17 220.87 164.65 221.9 161.54 220.09C158.43 218.28 157.39 219.31 157.65 220.6C157.91 221.89 162.32 223.45 162.32 223.45C162.32 223.45 156.62 223.45 154.03 222.68C151.44 221.91 153.03 223.68 153.77 225.01C154.51 226.34 159.47 228.38 161.28 228.38C162.859 228.479 164.424 228.74 165.95 229.16C165.95 229.16 173.95 248.85 177.87 254.04C181.79 259.23 186.68 267.77 191.09 263.11C195.5 258.45 202.23 228.64 202.23 228.64",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M189.17 232.32C188.35 241.62 188.17 250.68 187.17 251.18C185.09 252.18 173.34 235.18 171.07 227.78C170.58 226.2 170.84 225.53 167.99 223.19C165.14 220.85 164.62 221.9 161.51 220.09C158.4 218.28 157.36 219.31 157.62 220.6C157.88 221.89 162.29 223.45 162.29 223.45C162.29 223.45 156.59 223.45 154 222.68C151.41 221.91 153 223.68 153.74 225.01C154.48 226.34 159.44 228.38 161.25 228.38C162.829 228.479 164.394 228.74 165.92 229.16C165.92 229.16 173.92 248.85 177.84 254.04C181.76 259.23 186.65 267.77 191.06 263.11C193.69 260.31 197.16 248.53 199.53 239.5C195.63 234.7 192 232.87 189.17 232.32Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M203.27 383.62C203.27 383.62 197.05 388.02 197.56 390.62C198.07 393.22 202.49 394.77 203.01 395.55C203.53 396.33 209.09 401.85 211.55 401.97C214.01 402.09 213.35 400.41 212.38 398.76C211.41 397.11 208.45 392.18 208.45 389.85C208.438 388.365 208.264 386.887 207.93 385.44L203.27 383.62Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M202.229 353.81C202.229 353.81 194.449 354.48 193.719 354.6C192.989 354.72 191.289 354.6 192.259 359.71C193.229 364.82 192.379 369.93 193.359 372.97C194.339 376.01 195.419 376.97 195.909 376.49C196.399 376.01 197.849 371.26 199.439 367.37C200.988 364.016 202.786 360.784 204.819 357.7L202.229 353.81Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M199 359.37L198.46 354.15C196.37 354.33 194.13 354.54 193.75 354.6C193.02 354.73 191.32 354.6 192.29 359.71C193.26 364.82 192.41 369.93 193.39 372.97C194.37 376.01 195.45 376.97 195.94 376.49C196.43 376.01 197.88 371.26 199.47 367.37C200.515 364.998 201.725 362.703 203.09 360.5C201.809 359.871 200.422 359.488 199 359.37Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M208.45 389.84C208.447 388.994 208.387 388.148 208.27 387.31L204.61 388.91L200.06 386.31C198.63 387.7 197.32 389.37 197.56 390.61C198.08 393.2 202.49 394.76 203.01 395.54C203.53 396.32 209.09 401.84 211.55 401.96C214.01 402.08 213.35 400.4 212.38 398.75C211.41 397.1 208.45 392.17 208.45 389.84Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M104.43 407.52C129.736 407.52 150.25 403.114 150.25 397.68C150.25 392.245 129.736 387.84 104.43 387.84C79.1247 387.84 58.6104 392.245 58.6104 397.68C58.6104 403.114 79.1247 407.52 104.43 407.52Z",
    fill: "#226BF6"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.43 407.52C129.736 407.52 150.25 403.114 150.25 397.68C150.25 392.245 129.736 387.84 104.43 387.84C79.1247 387.84 58.6104 392.245 58.6104 397.68C58.6104 403.114 79.1247 407.52 104.43 407.52Z",
    fill: "white"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8301 269.78C97.8301 269.78 91.0001 318.78 88.0001 327.78C85.0001 336.78 81.0001 365.78 79.3301 374.78C78.3797 379.738 77.7119 384.746 77.3301 389.78L81.6701 391.12C81.6701 391.12 102 340.12 107.33 329.45C110.75 322.332 113.324 314.837 115 307.12C115 307.12 119 334.12 119 342.45C119 350.78 121.67 376.78 122.33 381.12C122.99 385.46 124.33 390.78 124.33 390.78L128.33 390.12C128.33 390.12 134.67 353.45 135.67 334.78C136.67 316.11 133.67 289.78 131.67 281.12C130.732 276.693 129.448 272.346 127.83 268.12C127.83 268.12 107.33 272.78 97.8301 269.78Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M116.46 307.19L124.92 286.95",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M117.97 304.17L124.32 296.32",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M101 213.12C101 213.12 97.6701 213.95 80.1701 223.28C62.6701 232.61 48.0501 244.09 53.0501 250.09C58.0501 256.09 91.8101 270.47 91.8101 270.47L94.3301 266.78C94.3301 266.78 68.0501 249.59 68.0501 246.26C68.0501 242.93 90.1701 236.12 90.1701 236.12L97.8301 269.78C102.587 271.906 107.813 272.768 113 272.28C118.19 272.005 123.255 270.585 127.83 268.12L129.83 233.45C129.83 233.45 150.67 230.12 156.5 218.28C162.33 206.44 154.33 178.28 154.33 178.28L150.83 178.62C150.83 178.62 151.17 205.95 148.33 211.12C145.49 216.29 122.83 212.62 114.33 211.62C105.83 210.62 101 213.12 101 213.12Z",
    fill: "#226BF6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M102.56 233.78L90.1699 236.12L100.15 238.92",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M130.06 225.32L129.83 233.45L134.89 221.7",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M101.83 206.28C101.83 206.28 99.0005 206.78 98.3305 209.28C97.7121 211.918 97.7706 214.67 98.5005 217.28C99.1705 219.12 101.67 223.78 101.67 223.78C101.67 223.78 107.96 217.56 108.91 217.78C113.56 218.84 116.16 219.29 118.58 219.9C118.58 219.9 117.33 210.29 114.67 207.63C112.01 204.97 103.5 206 101.83 206.28Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5 200.62C99.5 200.62 101.33 207.12 101.33 209.62C101.33 212.12 109 221.78 109 221.78L112.17 208.78L110.83 200.28C110.83 200.28 104 204.28 99.5 200.62Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M113.17 181.12C113.17 181.12 113.67 189.95 115.17 193.62C116.67 197.29 115.5 203.12 111.83 205.28C108.16 207.44 102.67 205.12 99.4998 202.95C96.3298 200.78 94.8298 196.28 93.1698 191.28C91.5098 186.28 91.3298 179.12 96.6698 176.78C102.01 174.44 113.17 181.12 113.17 181.12Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1698 195.62C95.1698 195.62 98.6698 194.45 98.6698 192.78C98.6698 191.11 97.1698 190.12 96.9998 187.62C96.8298 185.12 100.33 183.78 100.33 182.28C100.341 181.435 100.23 180.593 99.9998 179.78C99.9998 179.78 107.83 182.62 112.5 182.62C117.17 182.62 118.17 178.78 116.83 177.78C115.49 176.78 119.67 178.45 118 174.95C116.33 171.45 108.17 168.78 100.17 171.12C92.1698 173.46 91.1698 176.95 91.1698 176.95C91.1698 176.95 84.3298 179.95 84.8298 184.78C85.3298 189.61 92.9998 195.45 93.6698 196C94.3398 196.55 95.1698 195.62 95.1698 195.62Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5005 197.45C97.5005 197.45 95.3305 193.12 93.3305 193.95C91.3305 194.78 92.6705 197.12 94.8305 198.95C96.9905 200.78 98.3305 200.12 98.3305 200.12",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5005 197.45C97.5005 197.45 95.3305 193.12 93.3305 193.95C91.3305 194.78 92.6705 197.12 94.8305 198.95C96.9905 200.78 98.3305 200.12 98.3305 200.12",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M150.65 178.62C150.65 178.62 149.54 171.85 149.96 170.62C150.38 169.39 153.13 166.62 154.24 167.72C155.35 168.82 156.44 172.14 155.62 173.93C155.039 175.334 154.606 176.795 154.33 178.29L150.65 178.62Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M150.37 175.72C150.37 175.72 148.71 170.72 148.71 169.23C148.784 167.092 149.062 164.966 149.54 162.88C149.96 161.36 151.2 162.88 151.2 164.26C151.168 165.414 151.074 166.566 150.92 167.71C150.92 167.71 152.58 169.92 152.44 171.71L152.3 173.51",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M150.37 175.72C150.37 175.72 148.71 170.72 148.71 169.23C148.784 167.092 149.062 164.966 149.54 162.88C149.96 161.36 151.2 162.88 151.2 164.26C151.168 165.414 151.074 166.566 150.92 167.71C150.92 167.71 152.58 169.92 152.44 171.71L152.3 173.51",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M157.87 161.78C157.741 161.485 157.553 161.219 157.317 160.999C157.082 160.779 156.804 160.609 156.5 160.5C156 160.33 155.5 160.39 155.44 161.3C155.34 163.12 156.56 171.3 156.83 169.51C157.08 167.92 158.74 163.68 157.87 161.78Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M156.9 163.28C156.771 162.986 156.584 162.721 156.351 162.501C156.117 162.281 155.841 162.111 155.54 162C155.04 161.83 154.54 161.89 154.48 162.8C154.38 164.62 156.56 170.36 156.83 168.57C157.08 167 157.78 165.18 156.9 163.28Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M156.69 165.1C156.512 164.726 156.227 164.412 155.87 164.2C155.28 163.88 154.42 163.61 154.35 164.8C154.26 166.62 156.35 171.64 156.61 169.8C156.87 167.96 157.67 167.08 156.69 165.1Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M155.91 166.82C155.78 166.527 155.593 166.263 155.359 166.043C155.126 165.823 154.851 165.652 154.55 165.54C154.05 165.37 153.55 165.43 153.49 166.34C153.39 168.16 156.02 173.7 156.3 171.91C156.721 170.216 156.584 168.431 155.91 166.82Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3298 389.78C77.3298 389.78 71.3298 397.45 70.9998 401.78C70.6698 406.11 79.9998 399.45 81.6698 391.12L77.3298 389.78Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M128.33 390.12C128.33 390.12 141.67 397.45 138.67 398.78C135.67 400.11 128.33 395.45 124.33 390.78L128.33 390.12Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3306 266.78C94.3306 266.78 103.131 267.98 103.131 269.78C103.149 270.279 103.033 270.774 102.794 271.212C102.554 271.651 102.201 272.016 101.771 272.27C101.771 272.27 101.091 273.85 97.7005 274.27C94.3105 274.69 91.8105 270.42 91.8105 270.42L94.3306 266.78Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebration);
export default __webpack_public_path__ + "static/media/celebration.da708d8cec8d4f4c9cd182d2b70379dd.svg";
export { ForwardRef as ReactComponent };